require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-introducing-holly-francis.json") })
        }
      }, "path---news-introducing-holly-francis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-introducing-holly-francis!./.cache/json/news-introducing-holly-francis.json
// module id = 1423
// module chunks = 231608221292675